

import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { BaseUrl } from "../../Helper/BaseUrl";
import { toastErrorr, toastSuccesss } from "../../Helper/ToastMessage";


// Get Table Data
export const PoleEleMasterTableDataAPI = createAsyncThunk("PoleEleMasterTableData", async ({ data }) => {
    const {
        M_ELEC_PoleID,
        M_ELEC_PillerID,
        M_ELEC_LocationID,
        Flag,
        handleGetMapData,
        M_UserID,
        token,
        From,
        To,
        M_WardID,
    } = data


    var myHeaders = new Headers();
    myHeaders.append("Authorization", "Bearer " + token);

    var requestOptions = {
        method: 'GET',
        headers: myHeaders,
        redirect: 'follow'
    };

    // return fetch(`${BaseUrl}/Electrical/Get_M_ELEC_Pole_Select?M_ELEC_PoleID=${M_ELEC_PoleID ? M_ELEC_PoleID:'0'}&M_WardID=${M_WardID}&M_ELEC_LocationID=${M_ELEC_LocationID}&M_ELEC_PillerID=${M_ELEC_PillerID}&Flag=${Flag}&M_UserID=${M_UserID}&From=${From}&To=${To}`, requestOptions)
    return fetch(`${BaseUrl}/Electrical/Get_M_ELEC_Pole_Select?M_WardID=${M_WardID ? M_WardID:'0'}&M_ELEC_PillerID=${M_ELEC_PillerID ? M_ELEC_PillerID:'0'}&Flag=${Flag}&M_UserID=${M_UserID}&From=${From}&To=${To}`, requestOptions)
        .then((res) => res.json())
        .then((result) => {
            if (result.code >= 200 && result.code <= 300 && result?.data) {
                handleGetMapData && handleGetMapData(result?.data?.table)
                return result.data
            } else {
                handleGetMapData && handleGetMapData(null)
                return result
            }
        })
})

const PoleEleMasterTableDataSlice = createSlice({
    name: "PoleEleMasterTableData",
    initialState: {
        isLoading: false,
        tableData: null,
        isError: false,
    },
    extraReducers: (builder) => {
        builder.addCase(PoleEleMasterTableDataAPI.pending, (state, action) => {
            state.isLoading = true;
        });
        builder.addCase(PoleEleMasterTableDataAPI.fulfilled, (state, action) => {
            state.isLoading = false;
            state.tableData = action.payload;
        });
        builder.addCase(PoleEleMasterTableDataAPI.rejected, (state, action) => {
            console.log("Error", action.payload);
            state.isLoading = false;
            state.isError = true;
            state.tableData = null;
            // toastErrorr('Something went wrong')
        });
    },
})

export const PoleEleMasterTableDataReducer = PoleEleMasterTableDataSlice.reducer


// InsertUpdate Table Data

export const PoleEleMasterPostDataAPI = createAsyncThunk("PoleEleMasterPostData", async ({ data }) => {
    const {
        M_ELEC_PoleID,
        M_WardID,
        M_ELEC_LocationID,
        M_ELEC_PillerID,
        PoleNumber,
        AreaName,
        Photo,
        Latitude,
        Longitude,
        M_UserID,
        Flag,
        token,
        setLoading,
        handleIsPost,
        handleOnCloseClick
    } = data

    var myHeaders = new Headers();
    myHeaders.append("Authorization", "Bearer " + token);

    var formdata = new FormData();
    if (Flag == "Update") {
        formdata.append("M_ELEC_PoleID", M_ELEC_PoleID);
    }
    formdata.append("M_WardID", M_WardID);
    formdata.append("M_ELEC_LocationID", M_ELEC_LocationID);
    formdata.append("M_ELEC_PillerID", M_ELEC_PillerID);
    formdata.append("PoleNumber", PoleNumber);
    formdata.append("AreaName", AreaName);
    formdata.append("Photo", Photo);
    formdata.append("Latitude", Latitude);
    formdata.append("Longitude", Longitude);
    formdata.append("M_UserID", M_UserID);
    formdata.append("Flag", Flag);

    var requestOptions = {
        method: Flag == "Update" ? 'PATCH' : 'POST',
        headers: myHeaders,
        body: formdata,
        redirect: 'follow'
    };
    setLoading(true)

    let url
    if (Flag == "Update") {
        url = `${BaseUrl}/Electrical/Post_M_ELEC_Pole_Update`
    } else {
        url = `${BaseUrl}/Electrical/Post_M_ELEC_Pole_Insert`
    }
    fetch(url, requestOptions)
        .then((res) => res.json())
        .then((result) => {
            if (result.code >= 200 && result.code <= 300 && result.data) {
                handleIsPost()
                toastSuccesss(result.message)
                handleOnCloseClick()
                setLoading(false)
                return result.data
            } else {
                setLoading(false)
                toastErrorr(result.message)
            }
            return result
        })
})

const PoleEleMasterPostDataSlice = createSlice({
    name: "PoleEleMasterPostData",
    initialState: {
        isLoading: false,
        tableData: null,
        isError: false,
    },
    extraReducers: (builder) => {
        builder.addCase(PoleEleMasterPostDataAPI.pending, (state, action) => {
            state.isLoading = true;
        });
        builder.addCase(PoleEleMasterPostDataAPI.fulfilled, (state, action) => {
            state.isLoading = false;
            state.tableData = action.payload;
        });
        builder.addCase(PoleEleMasterPostDataAPI.rejected, (state, action) => {
            console.log("Error", action.payload);
            state.isLoading = false;
            state.isError = true;
            state.tableData = null;
            // toastErrorr('Something went wrong')
        });
    },
})

export const PoleEleMasterPostDataReducer = PoleEleMasterPostDataSlice.reducer



// Delete Table Data

export const PoleELEMasterDeleteAPI = createAsyncThunk("PoleELEMasterDelete", async ({ data }) => {
    const {
        M_ELEC_PoleID,
        M_UserID,
        handleIsPost,
        token,
        handleDeleteCloseClick
    } = data

    var myHeaders = new Headers();
    myHeaders.append("Authorization", "Bearer " + token);

    var formdata = new FormData();
    formdata.append("M_ELEC_PoleID", M_ELEC_PoleID);
    formdata.append("M_UserID", M_UserID);

    var requestOptions = {
        method: 'DELETE',
        headers: myHeaders,
        body: formdata,
        redirect: 'follow'
    };

    return fetch(`${BaseUrl}/Electrical/Post_M_ELEC_Pole_Delete`, requestOptions)
        .then((res) => res.json())
        .then((result) => {
            if (result.status) {
                handleIsPost()
                toastSuccesss(result.message)
                handleDeleteCloseClick()
            } else {
                toastErrorr(result.message)
                handleDeleteCloseClick()
            }
            return result

        })
})

const PoleELEMasterDeleteSlice = createSlice({
    name: "PoleELEMasterDelete",
    initialState: {
        isDeleteLoading: false,
        tableData: null,
        isError: false,
    },
    extraReducers: (builder) => {
        builder.addCase(PoleELEMasterDeleteAPI.pending, (state, action) => {
            state.isDeleteLoading = true;
        });
        builder.addCase(PoleELEMasterDeleteAPI.fulfilled, (state, action) => {
            state.isDeleteLoading = false;
            state.tableData = action.payload;

        });
        builder.addCase(PoleELEMasterDeleteAPI.rejected, (state, action) => {
            console.log("Error", action.payload);
            state.isDeleteLoading = false;
            state.isError = true;
            state.tableData = null;
            // toastErrorr('Something went wrong')
        });
    },
})

export const PoleELEMasterDeleteReducer = PoleELEMasterDeleteSlice.reducer




// Get Table Data
export const Get_M_ELEC_Piller_Wise_PoleCount_SelectDataAPI = createAsyncThunk("Get_M_ELEC_Piller_Wise_PoleCount_SelectData", async ({ data }) => {
    const {
        M_ELEC_PillerID,
        M_ELEC_LocationID,
        M_UserID,
        token,
        From,
        To,
        M_WardID,
    } = data


    var myHeaders = new Headers();
    myHeaders.append("Authorization", "Bearer " + token);

    var requestOptions = {
        method: 'GET',
        headers: myHeaders,
        redirect: 'follow'
    };

    return fetch(`${BaseUrl}/Electrical/Get_M_ELEC_Piller_Wise_PoleCount_Select?M_WardID=${M_WardID}&M_ELEC_LocationID=${M_ELEC_LocationID}&M_ELEC_PillerID=${M_ELEC_PillerID}&M_UserID=${M_UserID}&From=${From}&To=${To}`, requestOptions)
        .then((res) => res.json())
        .then((result) => {
            if (result.code >= 200 && result.code <= 300 && result.data) {
                return result.data
            } else {
                return result
            }
        })
})

const Get_M_ELEC_Piller_Wise_PoleCount_SelectDataSlice = createSlice({
    name: "Get_M_ELEC_Piller_Wise_PoleCount_SelectData",
    initialState: {
        isLoading: false,
        tableData: null,
        isError: false,
    },
    extraReducers: (builder) => {
        builder.addCase(Get_M_ELEC_Piller_Wise_PoleCount_SelectDataAPI.pending, (state, action) => {
            state.isLoading = true;
        });
        builder.addCase(Get_M_ELEC_Piller_Wise_PoleCount_SelectDataAPI.fulfilled, (state, action) => {
            state.isLoading = false;
            state.tableData = action.payload;
        });
        builder.addCase(Get_M_ELEC_Piller_Wise_PoleCount_SelectDataAPI.rejected, (state, action) => {
            console.log("Error", action.payload);
            state.isLoading = false;
            state.isError = true;
            state.tableData = null;
            toastErrorr('Something went wrong')
        });
    },
})

export const Get_M_ELEC_Piller_Wise_PoleCount_SelectDataReducer = Get_M_ELEC_Piller_Wise_PoleCount_SelectDataSlice.reducer



/// Location Api

export const PoleMasterGeoLocationDataAPI = createAsyncThunk("PoleMasterGeoLocationData", async ({ data }) => {
    const {
        UserID,
        token,
        From,
        To,
        M_AssetTypeID,
        M_WardID,
        M_ZoneID,
        M_AssetID,
        Language,
    } = data


    var myHeaders = new Headers();
    myHeaders.append("Authorization", "Bearer " + token);

    var requestOptions = {
        method: 'GET',
        headers: myHeaders,
        redirect: 'follow'
    };

    return fetch(`${BaseUrl}/Master/Get_WEB_GD_M_Asset_GeoTagging_Select?M_AssetID=${M_AssetID ? M_AssetID : '0'}&M_AssetTypeID=${M_AssetTypeID ? M_AssetTypeID : '0'}&M_WardID=${M_WardID ? M_WardID : '0'}&M_ZoneID=${M_ZoneID ? M_ZoneID : '0'}&M_UsersID=${UserID}&Language=${Language}&From=${From}&To=${To}`, requestOptions)
        .then((res) => res.json())
        .then((result) => {
            if (result.code >= 200 && result.code <= 300 && result.data) {
                return result.data
            } else {
                return result
            }
        })
})

const PoleMasterGeoLocationDataSlice = createSlice({
    name: "PoleMasterGeoLocationData",
    initialState: {
        isLoadinglocation: false,
        locationData: null,
        isError: false,
    },
    extraReducers: (builder) => {
        builder.addCase(PoleMasterGeoLocationDataAPI.pending, (state, action) => {
            state.isLoadinglocation = true;
        });
        builder.addCase(PoleMasterGeoLocationDataAPI.fulfilled, (state, action) => {
            state.isLoadinglocation = false;
            state.locationData = action.payload;
        });
        builder.addCase(PoleMasterGeoLocationDataAPI.rejected, (state, action) => {
            console.log("Error", action.payload);
            state.isLoadinglocation = false;
            state.isError = true;
            state.locationData = null;
            toastErrorr('Something went wrong')
        });
    },
})

export const PoleMasterGeoLocationDataReducer = PoleMasterGeoLocationDataSlice.reducer